import _ from 'lodash';
import axios from 'axios';
import { ValueLabel } from '../types';

async function checkForExistingUser(
  items: { type: string; value: string }[],

): Promise<{}> {

  const response = await axios.post('/api/v2/check-user', items);
  return response;
}

/**
 * Gets the current currency code from the server and returns it.
 *
 * @return {Promise<string>}
 */
export default _.memoize(checkForExistingUser, (...args) => JSON.stringify(args));
